import { Grid, styled } from "@mui/material";

export const FullWidthGrid = styled(Grid)(() => ({ width: "100%" }));
